import BaseList from '@material-ui/core/List'

const List = BaseList

export default List
